module.exports = __webpack_public_path__ + "img/0-1.da4622e8.png";